import { IProcessWarning } from '../../Features/Processes/Components/ProcessHeaderBase/ProcessHeaderBase';
import DatabaseSelect from '../DatabaseSelect/DatabaseSelect';
import { IDatabase } from '../../Features/Login/Contexts/LoginStateContext/LoginStateContext';

interface IProps extends IDatabaseListProps {
  disabled?: boolean;
}

export interface IDatabaseListProps {
  size: 'small' | 'large';
  databases: IDatabase[];
  selectedDatabases: IDatabase[];
  showLabel?: boolean;
  warnings?: IProcessWarning[];
  fixedWidth?: boolean;
}

/**
 * Komponent för att visa vilka enheter användaren har tillgång till. Passar till större skärmstorlekar.
 */
const DatabaseList: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { databases, ...rest } = props;
  const tmpDatabases = databases.slice(0);

  return <DatabaseSelect databases={tmpDatabases} {...rest} />;
};

export default DatabaseList;
